import * as types from './types'

const data = {
	loading: false,
	success: false,
	failed: false,
	data: null,
}

const initialState = {
	dictValues: data,
	dictNomination: data,
	dictParams: data,

	emplXml: data,
	emplList: data,

	mioUserCheck: data,
	mioById: data,
	mioList: data,
	mioCheckRow: data,
	mioXml: data,
	mioReport: data,

	dtspMioList: data,
	dtspReportList: data,
	dtspReportXml: data,
	dtspReqsList: data,
	dtspReqsOne: data,
	dtspReqsPage: data,
}

export const reducer = (state = initialState, action) => {
	const { type, payload } = action
	switch (type) {
		case types.GET_DICT_VALUES:
			return { ...state, dictValues: { ...data, loading: true } }

		case types.GET_DICT_VALUES_DONE:
			return { ...state, dictValues: { ...data, data: payload, success: true } }

		case types.GET_DICT_VALUES_FAIL:
			return { ...state, dictValues: { ...data, failed: true } }



		case types.GET_DICT_NOMINATION:
			return { ...state, dictNomination: { ...data, loading: true } }

		case types.GET_DICT_NOMINATION_DONE:
			return { ...state, dictNomination: { ...data, data: payload, success: true } }

		case types.GET_DICT_NOMINATION_FAIL:
			return { ...state, dictNomination: { ...data, failed: true } }


		case types.GET_DICT_PARAMS:
			return { ...state, dictParams: { ...data, loading: true } }

		case types.GET_DICT_PARAMS_DONE:
			return { ...state, dictParams: { ...data, data: payload, success: true } }

		case types.GET_DICT_PARAMS_FAIL:
			return { ...state, dictParams: { ...data, failed: true } }


		case types.SET_EMPL_SIGN:
		case types.SET_EMPL_XML:
			return { ...state, emplXml: { ...data, loading: true } }

		case types.SET_EMPL_SIGN_DONE:
		case types.SET_EMPL_XML_DONE:
			return { ...state, emplXml: { ...data, data: payload, success: true } }

		case types.SET_EMPL_SIGN_FAIL:
		case types.SET_EMPL_XML_FAIL:
			return { ...state, emplXml: { ...data, failed: true } }


		case types.GET_EMPL_LIST:
			return { ...state, emplList: { ...data, loading: true } }

		case types.GET_EMPL_LIST_DONE:
			return { ...state, emplList: { ...data, data: payload, success: true } }

		case types.GET_EMPL_LIST_FAIL:
			return { ...state, emplList: { ...data, failed: true } }


		case types.GET_MIO_CHECK_USER:
			return { ...state, mioUserCheck: { ...data, loading: true } }

		case types.GET_MIO_CHECK_USER_DONE:
			return { ...state, mioUserCheck: { ...data, data: payload, success: true } }

		case types.GET_MIO_CHECK_USER_FAIL:
			return { ...state, mioUserCheck: { ...data, failed: true } }


		case types.GET_MIO_BY_ID:
			return { ...state, mioById: { ...data, loading: true } }

		case types.GET_MIO_BY_ID_DONE:
			return { ...state, mioById: { ...data, data: payload, success: true } }

		case types.GET_MIO_BY_ID_FAIL:
			return { ...state, mioById: { ...data, failed: true } }


		case types.GET_MIO_LIST:
			return { ...state, mioList: { ...data, loading: true } }

		case types.GET_MIO_LIST_DONE:
			return { ...state, mioList: { ...data, data: payload, success: true } }

		case types.GET_MIO_LIST_FAIL:
			return { ...state, mioList: { ...data, failed: true } }


		case types.SET_MIO_ROW:
			return { ...state, mioCheckRow: { ...data, loading: true } }

		case types.SET_MIO_ROW_DONE:
			return { ...state, mioCheckRow: { ...data, data: payload, success: true } }

		case types.SET_MIO_ROW_FAIL:
			return { ...state, mioCheckRow: { ...data, failed: true } }


		case types.SET_MIO_XML:
		case types.SET_MIO_SIGN:
			return { ...state, mioXml: { ...data, loading: true } }

		case types.SET_MIO_XML_DONE:
		case types.SET_MIO_SIGN_DONE:
			return { ...state, mioXml: { ...data, data: payload, success: true } }

		case types.SET_MIO_XML_FAIL:
		case types.SET_MIO_SIGN_FAIL:
			return { ...state, mioXml: { ...data, failed: true } }

		case types.GET_MIO_REPORT:
			return { ...state, mioReport: { ...data, loading: true } }

		case types.GET_MIO_REPORT_DONE:
			return { ...state, mioReport: { ...data, data: payload, success: true } }

		case types.GET_MIO_REPORT_FAIL:
			return { ...state, mioReport: { ...data, failed: true } }


		case types.GET_DTSP_MIO_LIST:
			return { ...state, dtspMioList: { ...data, loading: true } }

		case types.GET_DTSP_MIO_LIST_DONE:
			return { ...state, dtspMioList: { ...data, data: payload, success: true } }

		case types.GET_DTSP_MIO_LIST_FAIL:
			return { ...state, dtspMioList: { ...data, failed: true } }


		case types.GET_DTSP_REPORT_LIST:
			return { ...state, dtspReportList: { ...data, loading: true } }

		case types.GET_DTSP_REPORT_LIST_DONE:
			return { ...state, dtspReportList: { ...data, data: payload, success: true } }

		case types.GET_DTSP_REPORT_LIST_FAIL:
			return { ...state, dtspReportList: { ...data, failed: true } }


		case types.SET_DTSP_REPORT_SIGN:
		case types.SET_DTSP_REPORT_XML:
			return { ...state, dtspReportXml: { ...data, loading: true } }

		case types.SET_DTSP_REPORT_SIGN_DONE:
		case types.SET_DTSP_REPORT_XML_DONE:
			return { ...state, dtspReportXml: { ...data, data: payload, success: true } }

		case types.SET_DTSP_REPORT_SIGN_FAIL:
		case types.SET_DTSP_REPORT_XML_FAIL:
			return { ...state, dtspReportXml: { ...data, failed: true } }


		case types.SET_DTSP_REQS_LIST:
			return { ...state, dtspReqsList: { ...data, loading: true } }

		case types.SET_DTSP_REQS_LIST_DONE:
			return { ...state, dtspReqsList: { ...data, data: payload, success: true } }

		case types.SET_DTSP_REQS_LIST_FAIL:
			return { ...state, dtspReqsList: { ...data, failed: true } }


		case types.GET_DTSP_REQS_ONE:
			return { ...state, dtspReqsOne: { ...data, loading: true } }

		case types.GET_DTSP_REQS_ONE_DONE:
			return { ...state, dtspReqsOne: { ...data, data: payload, success: true } }

		case types.GET_DTSP_REQS_ONE_FAIL:
			return { ...state, dtspReqsOne: { ...data, failed: true } }


		case types.GET_DTSP_REQS_PAGE:
			return { ...state, dtspReqsPage: { ...data, loading: true } }

		case types.GET_DTSP_REQS_PAGE_DONE:
			return { ...state, dtspReqsPage: { ...data, data: payload, success: true } }

		case types.GET_DTSP_REQS_PAGE_FAIL:
			return { ...state, dtspReqsPage: { ...data, failed: true } }

		default:
			return state
	}
}
